import { FirebaseActions, FirebaseTypes } from '@web_opxp/features';

/**
 * firebase analytics action builders
 */

// top button clicked action
export const firebaseTopButtonEventPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'o_button_start',
  parameters: [
    {
      key: 'button_clicked',
      value: 'top button',
    },
  ],
};
export const firebaseTopButtonClickAction = (): ReturnType<typeof FirebaseActions.analyticsEvent> => {
  return FirebaseActions.analyticsEvent(firebaseTopButtonEventPayload);
};

// get started clicked action
export const firebaseGetStartedEventPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'o_button_start',
  parameters: [
    {
      key: 'button_clicked',
      value: 'get started',
    },
  ],
};
export const firebaseGetStartedClickAction = (): ReturnType<typeof FirebaseActions.analyticsEvent> => {
  return FirebaseActions.analyticsEvent(firebaseGetStartedEventPayload);
};

// learn more clicked action
export const firebaseLearnMoreEventPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'o_button_start',
  parameters: [
    {
      key: 'button_clicked',
      value: 'learn more',
    },
  ],
};
export const firebaseLearnMoreClickAction = (): ReturnType<typeof FirebaseActions.analyticsEvent> => {
  return FirebaseActions.analyticsEvent(firebaseLearnMoreEventPayload);
};

// start introduction video clicked action
export const firebaseStartIntroEventPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'o_video_trigger',
  parameters: [
    {
      key: 'location',
      value: 'start',
    },
    {
      key: 'video_ID',
      value: '1',
    },
  ],
};
export const firebaseStartIntroClickAction = (): ReturnType<typeof FirebaseActions.analyticsEvent> => {
  return FirebaseActions.analyticsEvent(firebaseStartIntroEventPayload);
};

// skip introduction video clicked action
export const firebaseSkipIntroEventPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'o_video_trigger',
  parameters: [
    {
      key: 'location',
      value: 'skip',
    },
    {
      key: 'video_ID',
      value: '1',
    },
  ],
};
export const firebaseSkipIntroClickAction = (): ReturnType<typeof FirebaseActions.analyticsEvent> => {
  return FirebaseActions.analyticsEvent(firebaseSkipIntroEventPayload);
};

// play introduction video clicked action
export const firebasePlayIntroEventPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'o_video_trigger',
  parameters: [
    {
      key: 'location',
      value: 'play',
    },
    {
      key: 'video_ID',
      value: '1',
    },
  ],
};
export const firebasePlayIntroClickAction = (): ReturnType<typeof FirebaseActions.analyticsEvent> => {
  return FirebaseActions.analyticsEvent(firebasePlayIntroEventPayload);
};

// on introduction video started action
export const firebaseOnIntroStartedEventPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'o_video_started',
  parameters: [
    {
      key: 'video_ID',
      value: '1',
    },
  ],
};
export const firebaseOnIntroStartedAction = (): ReturnType<typeof FirebaseActions.analyticsEvent> => {
  return FirebaseActions.analyticsEvent(firebaseOnIntroStartedEventPayload);
};

// on introduction video close action
export const firebaseOnIntroCloseEventPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'o_video_close',
  parameters: [
    {
      key: 'video_ID',
      value: '1',
    },
  ],
};
export const firebaseOnIntroCloseAction = (): ReturnType<typeof FirebaseActions.analyticsEvent> => {
  return FirebaseActions.analyticsEvent(firebaseOnIntroCloseEventPayload);
};

// on introduction video completed action
export const firebaseOnIntroCompletedEventPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'o_video_completed',
  parameters: [
    {
      key: 'video_ID',
      value: '1',
    },
  ],
};
export const firebaseOnIntroCompletedAction = (): ReturnType<typeof FirebaseActions.analyticsEvent> => {
  return FirebaseActions.analyticsEvent(firebaseOnIntroCompletedEventPayload);
};
